// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"dff5d09d","463":"cd9c5ca5","482":"c953cebc","506":"d0ed2659","551":"b443bb19","670":"a775b6eb","711":"41facb7b","799":"911b58ba","835":"9777f9f4","864":"a55b1b57"}[chunkId] + ".chunk.js";
};